import React from 'react';

const MenuItemWithDescription = ({ title, description, price }) => {
  return (
    <div className="text-center mt-5 p-2 border-2 border-black">
      <h3 className="font-semibold text-[#9F785A] glacial-indifference-regular text-2xl">{title}</h3> {/* Title */}
      <p className="text-xl text-[#474B4E] glacial-indifference-regular">{description}</p> {/* Description */}
      <p className="font-semibold glacial-indifference-regular text-[#9F785A] text-2xl">{price}</p> {/* Price */}
    </div>
  );
};

export default MenuItemWithDescription;
